// extracted by mini-css-extract-plugin
module.exports = {"CheckBoxBase":"CheckBox_CheckBoxBase__2bR_z","CheckBoxPrimary":"CheckBox_CheckBoxPrimary__1apm6"};